import React from "react";

import { Box, Tooltip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

interface StyleProps {
  biggerFont: boolean;
}


const useStyles = makeStyles(() => ({
  value: ({ biggerFont }: StyleProps) => ({
    fontSize: biggerFont ? "3rem" : "1.25rem",
    fontWeight: 500,
    maxWidth: "300px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
  }),
  label: {
    fontSize: "0.75rem",
    letterSpacing: "1px",
    textTransform: "uppercase",
    color: "#939494",
    textAlign: "center",
  },
}));

export const ItemDisplay = ({
  label,
  value = "-",
  children,
  biggerFont = false,
  showTooltip = false,
}: {
  label: string;
  value?: string;
  biggerFont?: boolean;
  children?: React.ReactNode;
  showTooltip?: boolean;
}) => {
  const classes = useStyles({ biggerFont });

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      {children && children}
      {!children && (
        <Tooltip title={showTooltip ? value : ""} placement="top" arrow>
          <Typography className={classes.value}>{value}</Typography>
        </Tooltip>
      )}
      <Typography className={classes.label}>{label}</Typography>
    </Box>
  );
};
